import { render, staticRenderFns } from "./MedicoesListagem.vue?vue&type=template&id=9f56297e&scoped=true&"
import script from "./MedicoesListagem.vue?vue&type=script&lang=js&"
export * from "./MedicoesListagem.vue?vue&type=script&lang=js&"
import style0 from "./MedicoesListagem.vue?vue&type=style&index=0&id=9f56297e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f56297e",
  null
  
)

export default component.exports